import { ITEMS_CHUNK_SIZE } from "../../constants";
export const recalculatePagination = (pagination = {}) => {
    const loadedItems = (pagination.top || 0) + (pagination.skip || 0);
    return {
        top: pagination.top || ITEMS_CHUNK_SIZE,
        skip: loadedItems
    };
};
//# sourceMappingURL=recalculatePagination.js.map